import React from 'react';

import './style.css';
import SenderDetails from "./components/SenderDetails";
import ItemDetails from "./components/ItemDetails";
import FAQButton from "./components/FAQButton";
import PropTypes from "prop-types";
import ExpandMore from "./expand-more.svg"
import ExpandLess from "./expand-less.svg"
import ProofContainer from "./components/ProofContainer";
import {FormattedMessage} from 'react-intl';
import OrderMilestoneTimeline from "./components/OrderMilestoneTimeline";
import PaymentDetails from "../PaymentDetails"

export default class SwipeableTrackingCard extends React.Component {
  maxMobileScreenWidth = 768;

  constructor(props) {
    super(props);
    this.state = {
      cardPositionY: 10,
    };

    this.containerRef = React.createRef();
    this.touchStartingPointRef = React.createRef(0);
    this.containterStartingPointRef = React.createRef(0);
    this.scrollableContainerRef = React.createRef();
    this.cardTopMargin = 20;
  }

  static propTypes = {
    packageDescription: PropTypes.string.isRequired,
    storeOrderId: PropTypes.string.isRequired,
    customerName: PropTypes.string.isRequired,
    bottomCardHeight : PropTypes.func.isRequired,
    cardRef: PropTypes.object.isRequired,
    renderFixedDetails : PropTypes.func.isRequired,
    handleContainerResize : PropTypes.func.isRequired,
    isPortraitOrientation: PropTypes.bool,
    trackingEvents: PropTypes.object,
    documents: PropTypes.object,
    serviceType: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    subStatus: PropTypes.string.isRequired,
    cancelReasonDescription: PropTypes.string,
    receiverName: PropTypes.string,
    paymentDetails: PropTypes.object,
    onCardToggle: PropTypes.func, 
  };

  componentDidMount() {
    const { isDesktopView, bottomCardHeight } = this.props;
    if(!isDesktopView) {
     this.addTouchEventListeners();
    }

    this.setState({
      cardPositionY: window.innerHeight - bottomCardHeight() - this.cardTopMargin,
    }, () => {
      this.updateClosedCardPosition()
    })
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.isDesktopView) {
      this.removeTouchEventListeners();
    } else {
      this.addTouchEventListeners();
      this.updateClosedCardPosition()
    }
  }

  addTouchEventListeners = () => {
    this.containerRef.current.addEventListener("touchmove",this.handleTouchMove);
    this.containerRef.current.addEventListener("touchstart",this.handleTouchStart);
    this.containerRef.current.addEventListener("touchend",this.handleTouchEnd);
  }

  removeTouchEventListeners = () => {
    this.containerRef.current.removeEventListener("touchmove",this.handleTouchMove);
    this.containerRef.current.removeEventListener("touchstart",this.handleTouchStart);
    this.containerRef.current.removeEventListener("touchend",this.handleTouchEnd);
  }

  handleClick = () => {
    const { bottomCardHeight, onCardToggle } = this.props;
    let { cardPositionY } = this.state;
    if (this.scrollableContainerRef.current.scrollTop === 0) {
      if (cardPositionY === 0) {
        cardPositionY = window.innerHeight - bottomCardHeight() - this.cardTopMargin;
      } else {
        cardPositionY = 0;
      }
      
      this.setState({ cardPositionY }, () => {
        this.updateClosedCardPosition();
        if (onCardToggle) {
          onCardToggle(this.isCardOpen());
        }
      });
    }
  };


  updateClosedCardPosition = () => {
    if (this.state.cardPositionY !== 0) {
      this.setState({
        ...this.state,
        cardPositionY: window.innerHeight - this.props.bottomCardHeight() - this.cardTopMargin
      })
    }
  }

  handleTouchMove=(event)=> {
    const { bottomCardHeight } = this.props;
    let diff = this.touchStartingPointRef.current - event.changedTouches[0].clientY

    if(this.scrollableContainerRef.current.scrollTop === 0 && !(this.containterStartingPointRef.current === 0 && this.isSwipeUp(diff))) {
      const bottomLimit = window.innerHeight - bottomCardHeight() - this.cardTopMargin;
      let cardPositionY;
      if (this.containterStartingPointRef.current === 0) {
        cardPositionY = Math.abs(diff);
      } else {
        cardPositionY = bottomLimit - diff
      }
      if (event.changedTouches[0].clientY < 30) {
        cardPositionY = 0
      } else if (cardPositionY > bottomLimit) {
        cardPositionY = bottomLimit
      }
      this.setState({
        ...this.state,
        cardPositionY: cardPositionY
      })
    }
  }

  handleTouchStart=(event)=> {
    this.touchStartingPointRef.current = event.changedTouches[0].clientY;
    this.containterStartingPointRef.current = this.state.cardPositionY;
  }

  handleTouchEnd = (event) => {
    const { bottomCardHeight, onCardToggle } = this.props;
    let cardPositionY = event.changedTouches[0].clientY;
    if (this.scrollableContainerRef.current.scrollTop === 0 && this.touchStartingPointRef.current !== cardPositionY) {
      if (this.touchStartingPointRef.current > cardPositionY) {
        cardPositionY = 0;
      } else {
        cardPositionY = window.innerHeight - bottomCardHeight() - this.cardTopMargin;
      }
      
      this.setState({ cardPositionY }, () => {
        this.updateClosedCardPosition();
        if (onCardToggle) {
          onCardToggle(this.isCardOpen());
        }
      });
    }
  };


  isSwipeUp(diff) {
    return diff > 0
  }

  isCardOpen() {
    return this.state.cardPositionY === 0;
  }

  isGoSendCODOrder = () => {
    const codAmount = this.props.paymentDetails?.cashOnDeliveryAmount ?? 0;
    return codAmount > 0;
  }

  scrollContainerStyle() {
    const cardOpen = this.isCardOpen();
    if(cardOpen) {
      return {overflow: 'scroll'};
    }
    return {overflow: 'hidden'};
  }

  expandButton() {

    if(this.isCardOpen()) {
      if(this.isGoSendCODOrder()) {
        return (<><img alt="Less" src={ExpandLess}/>
        <FormattedMessage id="GoSend.COD.PaymentDetails.collapseTitle"/></>)
      } else {
        return (<><img alt="Less" src={ExpandLess}/>
        <FormattedMessage id="GoSendPartner.SeeLess"/></>)
      }
    }
    else {
      if(this.isGoSendCODOrder()) {
        return (<><img alt="More" src={ExpandMore}/>
        <FormattedMessage id="GoSend.COD.PaymentDetails.expandTitle"/></>)
      } else {
        return (<><img alt="More" src={ExpandMore}/>
        <FormattedMessage id="GoSendPartner.SeeDetails"/></>)
      }
    }
  }

  getStyles() {
    const { cardPositionY } = this.state;

    if(!this.props.isDesktopView) {
      return {transform: `translateY(${cardPositionY}px)`, height: window.innerHeight - this.cardTopMargin}
    }

    return {}
  }

  render() {
    const { cardRef, isPortraitOrientation } = this.props;
    const cashOnDeliveryAmount = this.props.paymentDetails?.cashOnDeliveryAmount ?? 0;
    const isGoSendCODBooking = cashOnDeliveryAmount > 0

    return (
      <>
        <div className="TrackingContainer-card SwipeableContainer" ref={this.containerRef} style={this.getStyles()}>
          <div className="CardDetailsContainer">
            <div className="ScrollableContainer" ref={this.scrollableContainerRef} style={this.scrollContainerStyle()}>
              <div className="FixedDetails" ref={cardRef}>
                <div className="Expand" onClick={this.handleClick}>
                  {this.expandButton()}
                </div>
                {this.props.renderFixedDetails(this.isCardOpen())}
                <div className="Divider"></div>
                {!isGoSendCODBooking && isPortraitOrientation && <SenderDetails storeOrderId={this.props.storeOrderId} customerName={this.props.customerName}/>}
              </div>
              <div>
                {!isGoSendCODBooking && !isPortraitOrientation && <SenderDetails storeOrderId={this.props.storeOrderId} customerName={this.props.customerName}/>}
                {!isGoSendCODBooking && (<ItemDetails packageDescription={this.props.packageDescription} />)}
                {!isGoSendCODBooking && this.props.trackingEvents && (<>
                  <div className="Divider"></div>
                  <OrderMilestoneTimeline
                    trackingEvents={this.props.trackingEvents}
                    serviceType={this.props.serviceType}
                    status={this.props.status}
                    subStatus={this.props.subStatus}
                    cancelReasonDescription={this.props.cancelReasonDescription}
                    receiverName={this.props.receiverName}/>
                </>)}
                {!isGoSendCODBooking  && Object.keys(this.props.documents || {}).length > 0 && (<>
                  <div className="Divider"></div>
                  <ProofContainer documents={this.props.documents}/>
                </>)}
                
                {isGoSendCODBooking && (
                  <>
                  <div className="Divider-payment-details"></div>
                  <PaymentDetails
                  status={this.props.status}
                  subStatus={this.props.subStatus}
                  paymentDetails={this.props.paymentDetails}
                  />
                  </>
                )}
              </div>
            </div>
            {!isGoSendCODBooking && (
               <FAQButton/>
            )}
          </div>
        </div>
        {this.isCardOpen() && !this.props.isDesktopView && (<div className="Backdrop"/>)}
      </>
    );
  }
}

